<template>
  <div class="mb-4">
    <div v-if="$store.state.user.is_root">
      <button class="btn btn-dager btn-icon mw" @click="cancelRequest">
        {{ "cancel_order" | setText("Отменить заявку") }}
      </button>
    </div>
  </div>
</template>
<script>
import { errorNotify } from "@/plugins/functions";

export default {
  methods: {
    async cancelRequest() {
      const url = `${this.currentRequest.service.api_endpoint_url}v1/order/cancel&id=${this.data.exchange_id}`;
      const method = "post";
      let data = {};
      this.$dialog
        .confirm(`Вы уверены, что хотите отменить заказ?`, {
          okText: "Да | To'g'ri",
          cancelText: "Нет | Yo'q",
        })
        .then(() => {
          this.$loading(true);
          var instance = this.$http.create();
          delete instance.defaults.headers.common["Authorization"];
          delete instance.defaults.headers.common["bid"];
          delete instance.defaults.headers.common["localization"];
          delete instance.defaults.headers.common["shop"];
          delete instance.defaults.headers.common["device"];
          delete instance.defaults.headers.common["tab"];
          delete instance.defaults.headers.common["root"];
          delete instance.defaults.headers.common["version"];
          const config = {
            method: method,
            url: url,
            data: data,
            headers: {
              common: {
                Authorization:
                  "Bearer " + this.currentRequest.service.api_token,
              },
            },
          };
          //REQUEST
          return instance(config)
            .then((response) => {
              this.$loading(false);
              const responseData = response.data;

              this.$emit("input", {
                delete: true,
              });
              return responseData;
            })
            .catch((error) => {
              this.$loading(false);
              return errorNotify(error, this.notify);
            })
            .finally(() => {});
        })
        .catch(() => {});
    },
  },
  props: ["value", "data", "currentRequest"],
};
</script>
<style>
</style>
 